import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService, EventsService, UtilService, VariablesService } from '../../shared/services';
import { IPaymentConfig } from '../payment/models/payment.model';
import { PaymentUtilService } from '../payment/services';

@Component({
  selector: 'app-otd-sip-toggle',
  templateUrl: './otd-sip-toggle.component.html',
  styleUrls: ['./otd-sip-toggle.component.scss']
})
export class OtdSipToggleComponent implements OnInit, OnDestroy {

  @Input() payment_config: IPaymentConfig;
  isContributeCalled = false;
  pre_currency = 'INR';

  subs: Subscription[] = [];

  constructor(
    public vars: VariablesService,
    private events: EventsService,
    private paymentUtil: PaymentUtilService,
    public util: UtilService,
    private api: ApiService
  ) { }

  ngOnInit(): void {
    this.setConfig();
  }

  setConfig() {
    this.subs.push(this.paymentUtil.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
        if (c?.currency) {
          this.getSipContribute();
        }
      }
    }));
  }

  async sipToggle(checked) {
    if (!this.isContributeCalled) {
      await this.getSipContribute();
    }
    this.paymentUtil.paymentConfig.next({ is_sip: checked });
    const payload = {
      eventName: 'toggleswitch',
      page_name: this.vars.pageName,
      info_1: checked ? 'sip' : 'one time'
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

  async getSipContribute() {
    return new Promise((resolve, reject) => {
      try {
        this.isContributeCalled = true;
        let qParam = `?currency=${this.payment_config.currency}&origin=${this.payment_config.origin}&${this.util.utm_url_string}`;
        const url = environment.APP.API_URLS.GET_RECURRING_CONTRIBUTE_DETAILS + qParam;
        this.api.get(url).subscribe(res => {
          this.paymentUtil.paymentConfig.next({ sip_contribute_details: res?.data?.data });
          this.isContributeCalled = false;
          resolve(true);
        });
      } catch (error) {
        reject(false);
      }
    });

  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
